"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zzUtils = require("@zz-common/zz-utils");

/**
 * @function
 * @name SetPicSize - 服务器端设置请求图片大小 
 * @desc 服务器端设置请求图片大小，为了节约网络请求资源，请在图片地址上都做此过滤，依赖 <a href="http://gitlab.zhuanspirit.com/zz-fe/setPicSize" target="_blank">@zz-app/setPicSize</a> 包
 * @param {string} url 图片地址
 * @param {number} [width] 图片宽度，最好同设计稿尺寸一致，甚至更宽
 * @param {number} [height] 图片高度，最好同设计稿尺寸一致，甚至更高
 * @example
 * import { SetPicSize } from '@zz-biz/utils';
 * // 示例1
 * SetPicSize('https://pic5.zhuanstatic.com/zhuanzh/n_v25d54fea032fd4a91ad6c48ef6b559806.jpg', 400, 400);
 * 
 * // return https://pic5.zhuanstatic.com/zhuanzh/n_v25d54fea032fd4a91ad6c48ef6b559806.jpg?w=400&h=400
 * @return {string} 新的图片地址
 */
var _default = _zzUtils.setPicSize;
exports["default"] = _default;